import { Link } from "react-router-dom";
import { ReactComponent as Ghost } from "../graphicalAssets/illustrations/ghost-solid.svg";
const Error404 = () => {
  return (
    <div className="content-error">
      <div className="content-error__ghost-icon">
        <Ghost />
      </div>
      <div className="content-error__text">
        <h2>The page you’re looking for can’t be found.</h2>
        <Link to={{ pathname: "/", state: { prevPath: "/404" } }}>
          Back to homepage
        </Link>
      </div>
    </div>
  );
};

export default Error404;
